<script>
import EventManagementMixin from '../event/EventManagementMixin.vue';
import GfAnalyticsMixin from '../inc/GfAnalyticsMixin.vue';
export default {
  name: 'TeamEvent',

  mixins: [EventManagementMixin,GfAnalyticsMixin],

  methods: {        
    stage(eventCampaignId, eventName, eventImagePath, eventUrl) {
      this.store.commit('change_event', {
        EventCampaignId : eventCampaignId.eventCampaignId || eventCampaignId, 
        EventName: eventCampaignId.eventName || eventName, 
        EventImagePath: eventCampaignId.eventImagePath || eventImagePath, 
        EventUrl: eventCampaignId.eventUrl || eventUrl,
        Router_Name: this.$route.name
      });

      if(this.store.state.selected_charity != '' && this.store.state.selected_event != '') {
        this.$router.push({name: 'complete_team' });
      }
      else {
        this.$router.push({name: 'charity_team' });
      }
      this.analytics({
        'event': 'create_page',
        'createType': 'team', 
        'stepNumber': '3 of 4',
        'stepName': 'select event',
        'causeName': this.store.state.selected_charity.BeneficiaryName,
        'eventName': eventCampaignId.eventName || eventName,
      });
    }
  }
}
</script>
